"use client";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomerProfile } from "../config/redux/slices/authAndAddressSlice";

export default function useProfileCheck(onLoginModalClose = null) {
  const dispatch = useDispatch();
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [hasChecked, setHasChecked] = useState(false);

  const { token } = useSelector((state) => state.auth);
  const isAuthenticated = !!token;

  useEffect(() => {
    // Only check profile if user is authenticated and we have a token
    if (isAuthenticated && token && !hasChecked) {
      setHasChecked(true);

      const checkProfile = async () => {
        try {
          const profileResult = await dispatch(fetchCustomerProfile()).unwrap();
          // console.log('Global profile check result:', profileResult);

          // Check if name exists in profile
          if (
            !profileResult?.value?.name ||
            profileResult.value.name.trim() === ""
          ) {
            // console.log(
            //   "No name found in global check, showing profile completion modal"
            // );
            setShowProfileModal(true);
          }
        } catch (error) {
          console.error("Global profile check error:", error);
          // Don't show modal on error to avoid blocking the user
        }
      };

      checkProfile();
    }

    // Reset hasChecked when user logs out
    if (!isAuthenticated) {
      setHasChecked(false);
    }
  }, [isAuthenticated, token, dispatch, hasChecked]);

  const handleProfileComplete = (profileData) => {
    // console.log("Global profile completed:", profileData);
    setShowProfileModal(false);
    // Login modal is already closed, so no need to close it again
  };

  const handleClose = () => {
    setShowProfileModal(false);
  };

  const triggerProfileCheck = async () => {
    if (isAuthenticated && token) {
      try {
        const profileResult = await dispatch(fetchCustomerProfile()).unwrap();
        // console.log("Manual profile check result:", profileResult);

        // Check if name exists in profile
        if (
          !profileResult?.value?.name ||
          profileResult.value.name.trim() === ""
        ) {
          // console.log(
          //   "No name found in manual check, closing login modal and showing profile completion modal"
          // );
          // Close login modal first, then show profile modal
          if (onLoginModalClose) {
            onLoginModalClose();
          }
          // Small delay to ensure login modal is closed before showing profile modal
          setTimeout(() => {
            setShowProfileModal(true);
          }, 100);
        } else {
          // If profile is complete, close the login modal
          // console.log("Profile is complete, closing login modal");
          if (onLoginModalClose) {
            onLoginModalClose();
          }
        }
      } catch (error) {
        console.error("Manual profile check error:", error);
        // On error, close the login modal to avoid blocking the user
        if (onLoginModalClose) {
          onLoginModalClose();
        }
      }
    }
  };

  return {
    showProfileModal,
    setShowProfileModal,
    handleProfileComplete,
    handleClose,
    triggerProfileCheck,
  };
}
